import { Card } from "primereact/card"

import { ErrorOutline, CheckCircleOutline } from "@material-ui/icons";

const Index = ({
  dataCompensCert,
  dataEventoCertidao,
  valrCompensado,
  valorEvento,
  numrProcessoCompensacao,
  descComplemento,
  handleImportarQuitacaoCompensacao
}) => {

  const existeQuitacaoCompensacaoNaLegada = dataCompensCert === dataEventoCertidao && valrCompensado === valorEvento && numrProcessoCompensacao === descComplemento

  return (
    <div className="p-col-12" style={{ padding: "0px 10px", marginBottom: "25px" }}>
      <Card
        className={`
            ${existeQuitacaoCompensacaoNaLegada
            ? "modal-card-importado"
            : "modal-card"
          }
           `}
      >
        <div style={{ display: "flex", alignItems: "center" }} onClick={handleImportarQuitacaoCompensacao}>
          {existeQuitacaoCompensacaoNaLegada ? (
            <CheckCircleOutline c style={{ color: "#067406", fontSize: "2.2rem", flex: "1" }} />
          ) : (
            <ErrorOutline style={{ color: "#e95c09", fontSize: "2.2rem", flex: "1" }} />
          )}
          <p className="m-0" style={{ lineHeight: "1.5", flex: "13" }}>
            Existe informação de Data, Valor e Nº Processo de Compensação no LEGADO. Click aqui se deseja importar.
        </p>
        </div>
      </Card>
    </div>
  )
}

export default Index;